<template>
  <div :class="{ newWrap: canCancelSubscription }">
    <div class="item-title">
      <div class="split" />
      金融权益如何使用
    </div>
    <div class="item-content">
      <p v-for="item in financeRule" :key="item" v-html="item" />
    </div>

    <div class="item-title">
      <div class="split" />
      生活权益如何使用
    </div>
    <div class="item-content">
      <p v-for="item in lifeRule" :key="item" v-html="item" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { defineComponent, onMounted, ref } from "@vue/composition-api";

import { jsonSafeParse } from "@/utils";

const vm = Vue.prototype;

export default defineComponent({
  props: ["canCancelSubscription"],
  setup() {
    const financeRule = ref([]);
    const lifeRule = ref([]);

    onMounted(() => {
      financeRule.value = jsonSafeParse(
        vm.$getConfigValue("JY_FINANCE_RULE"),
        []
      );
      lifeRule.value = jsonSafeParse(vm.$getConfigValue("JY_LIFE_RULE"), []);
    });

    return {
      financeRule,
      lifeRule,
    };
  },
});
</script>


<style scoped lang="less">
.newWrap {
  .item-content {
    background: rgba(245, 229, 206, 0.25);
  }
}

.item-title {
  display: flex;
  align-items: center;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  margin-top: 24px;

  .split {
    width: 2px;
    height: 14px;
    background: #e4d1b4;
    border-radius: 1px;
    margin-right: 4px;
  }
}

.item-content {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 12px;
  margin-top: 12px;

  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 23px;

  /deep/ span {
    font-weight: 600;
  }
}
</style>